

































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { PedidoPendiente } from '@/models/StateAlmacenes';

export default Vue.extend({
	name: 'Almacenes',
	computed: {
		...mapGetters('almacenes', ['tableData', 'isLoading', 'error']),
	},
	created() {
		this.refresh();
	},
	methods: {
		...mapActions('almacenes', ['fetchPendientes']),
		refresh() {
			(this as any).fetchPendientes();
		},
		goToDetalle(row: PedidoPendiente) {
			this.$router.push({ name: 'detalleAlmacenes', params: { id: String(row.id) } });
		},
		goToBack() {
			this.$router.replace({ path: '/redirect' }).then(() => {
				this.$router.replace({ name: 'Almacenes' });
			});
		},
	},
});
